module.exports = __webpack_public_path__ + "img/ioniq9-alt-26.039b5bf8.png";